// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#userDropdown {
  cursor: pointer;
}

.top-nav-action-btn,
.top-nav-action-btn.e-btn {
  width: 42px;
  min-width: 42px;
  height: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: #7b8491;
  box-shadow: none;
  line-height: 1;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.top-nav-action-btn:hover,
.top-nav-action-btn:focus-visible,
.top-nav-action-btn.e-btn:hover,
.top-nav-action-btn.e-btn:focus-visible {
  border-color: #cfe3ff;
  background: #eef6ff;
  color: #0066ff;
  outline: none;
  box-shadow: none;
}

.top-nav-action-icon,
.top-nav-action-btn .e-icons {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  font-size: 24px;
  line-height: 24px;
}

.top-nav-action-icon {
  stroke: currentColor;
}

.btn-outline-repsoft {
  color: #FF914D;
  border-color: #004369;
}

.btn-outline-repsoft:hover {
  background-color: #004369;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/top-nav-user/top-nav-user.component.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;;AAIA;;EAEI,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kFAAA;AADJ;;AAIA;;;;EAII,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AADJ;;AAIA;;EAEI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AADJ;;AAIA;EACI,oBAAA;AADJ;;AAIA;EACI,cAAA;EACA,qBAAA;AADJ;;AAGA;EACI,yBAAA;EACA,YAAA;AAAJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n#userDropdown {\n    cursor: pointer;\n}\n\n.top-nav-action-btn,\n.top-nav-action-btn.e-btn {\n    width: 42px;\n    min-width: 42px;\n    height: 42px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid transparent;\n    border-radius: 999px;\n    background: transparent;\n    color: #7b8491;\n    box-shadow: none;\n    line-height: 1;\n    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.top-nav-action-btn:hover,\n.top-nav-action-btn:focus-visible,\n.top-nav-action-btn.e-btn:hover,\n.top-nav-action-btn.e-btn:focus-visible {\n    border-color: #cfe3ff;\n    background: #eef6ff;\n    color: #0066ff;\n    outline: none;\n    box-shadow: none;\n}\n\n.top-nav-action-icon,\n.top-nav-action-btn .e-icons {\n    width: 24px;\n    height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: currentColor;\n    font-size: 24px;\n    line-height: 24px;\n}\n\n.top-nav-action-icon {\n    stroke: currentColor;\n}\n\n.btn-outline-repsoft {\n    color: #FF914D;\n    border-color: #004369;\n}\n.btn-outline-repsoft:hover {\n    background-color: #004369;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
